import { useCallback, useEffect, useState } from "react";
import { Ordem } from "./types";
import blogFetch from "../../axios/config";
import React from "react";
import Loading from "../../components/Loading";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { Button } from "react-bootstrap";
import "./style.css"
import { FormatDate } from "../../utils/DataUtils";

interface ListaOrdem {
    tela: string[]
    ordens: string[];
    data: Date[];
    lote: string[];
}

export function ListaOrdens() {
    const [ordens, setOrdens] = useState<ListaOrdem[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectdItems, setSelectedItems] = useState<number[]>([]);
    const [searchTerm, setSearchTerm] = useState(""); // Novo estado para busca

    const fetchOrdens = useCallback(async () => {
        try {
            setIsLoading(true);
            const { data } = await blogFetch.get<ListaOrdem[]>("SAGA_ListaProducao/getListaOrdens");
            setOrdens(data);
        } catch (error) {
            console.error("Erro ao buscar ordens:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchOrdens();
    }, []);

    const handleCheckboxChange = (index: number) => {
        setSelectedItems(prev =>
            prev.includes(index)
                ? prev.filter(item => item !== index)
                : [...prev, index]
        );
    };

    const handleImprirOrdem = async () => {
        if (selectdItems.length === 0) {
            alert("Selecione pelo menos um item para reimprimir");
            setSelectedItems([]);
            return;
        }

        await blogFetch.post('SAGA_ListaProducao/imprimirOrdens', selectdItems, { responseType: "blob" }).then(response => {
            if (response.data) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Ordem.xlsx";
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
                setSelectedItems([]);
                fetchOrdens();
            }
        }).catch(error => {
            console.error("Erro ao baixar o arquivo:", error);
        });
    };

    // Filtro da lista com base na busca
    const filteredOrdens = ordens.filter(ordem =>
        ordem.ordens.join(" ").toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Navbar />
            <Sidebar />
            <div className="app_body container_ordem">
                {isLoading ? (
                    <Loading />
                ) : (
                    <div className="content_ordem">
                        <div className="header_ordem">
                            <h1 className="title_ordem">Lista de Ordens Impressas</h1>
                            <button type="submit" onClick={handleImprirOrdem} className="btn_ordem">Gerar Tela</button>
                        </div>

                        {/* Campo de pesquisa */}
                        <div className="search_ordem">
                            <input
                                type="text"
                                placeholder="Buscar por ordem..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="search-input_ordem"
                            />
                        </div>

                        <form>
                            <div className="table_wrapper_ordem">
                                <table className="table_ordem">
                                    <thead className="thead_ordem">
                                        <tr>
                                            <th>Tela</th>
                                            <th>Ordem</th>
                                            <th>Serial</th>
                                            <th>Data</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredOrdens.map((ordem, i) => (
                                            <tr key={i} className="row_ordem">
                                                <td>{ordem.tela}</td>
                                                <td>{ordem.ordens}</td>
                                                <td>{ordem.lote}</td>
                                                <td>{FormatDate(ordem.data)}</td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectdItems.includes(Number(ordem.ordens))}
                                                        onChange={() => handleCheckboxChange(Number(ordem.ordens))}
                                                        className="checkbox-container"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </>
    );
}
